import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { get as _get } from 'lodash';
import { combineLatest, of as observableOf } from 'rxjs';

// Store
import { claimFnolQuery, DraftClaim } from '@amfam/claim/fnol/data-access';
import { PolicySelectors } from '@amfam/policy/data-access';
import { FnolRiskModel } from '@amfam/policy/models';

import * as fromRoot from '../core/store';

@Injectable()
export class ClaimResolve {
  private riskDescription = '';
  private risks: Array<FnolRiskModel> = new Array<FnolRiskModel>();
  private currentRisk: FnolRiskModel;

  constructor(private store: Store<fromRoot.RootState>) {}

  resolve(route: ActivatedRouteSnapshot) {
    combineLatest(
      this.store.select(PolicySelectors.selectClaimableRiskModels),
      this.store.select(claimFnolQuery.getClaimFnolSelectedEntity),
      (risks, draftClaim: DraftClaim) => {
        return {
          risks: risks,
          draftClaim: draftClaim
        };
      }
    ).subscribe(data => {
      this.risks = data.risks;
      if (_get(data, 'draftClaim.claimNumber', '')) {
        this.currentRisk = this.risks.find(
          risk => risk.vin === _get(data.draftClaim, 'autoClaimDetail.vehicles[0].vin', '')
        );
        this.riskDescription = this.currentRisk ? this.currentRisk.description : '';
        /**
         * Risks other than auto will not have claimNumber. Get riskDescription by querying with riskId.
         */
      } else if (_get(data, 'draftClaim.riskId', '')) {
        this.currentRisk = this.risks.find(risk => risk.id === _get(data.draftClaim, 'riskId', ''));
        this.riskDescription = this.currentRisk ? this.currentRisk.description : '';
      }
    });
    return observableOf(this.riskDescription);
  }
}
